import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-navigation-organisation',
  templateUrl: './side-navigation-organisation.component.html',
  styleUrls: ['./side-navigation-organisation.component.scss']
})
export class SideNavigationOrganisationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
